'use strict';

var React = require('react');
var Typography = require('../Typography/Typography.js');
var TableCell = require('./TableCell.js');
var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    root: {
      padding: '16px 24px 16px 24px'
    }
  };
};

var TableBodyCell = function TableBodyCell(props) {
  return React__default["default"].createElement(TableCell, props, React__default["default"].createElement(Typography, {
    variant: 'body1'
  }, props.children));
};

var TableBodyCell$1 = withStyles(styles)(TableBodyCell);

module.exports = TableBodyCell$1;
